<!--众筹专用订单创建页面-->
<template>
  <div class="crowdfunding-pay">
    <fixed-header title="确认订单"></fixed-header>
    <div class="crowdfunding-pay__main scroll-touch">
      <div
          :mg-stat-custom="'label=title&cont=点击地址&direct=web&cntp=haowu_pay&mod=pay_address'"
          :mg-stat-lob="`crowdId =${crowdId}`"
          class="crowdfunding-pay__address"
          mg-stat-click
          mg-stat-mod="pay_address"
          @click="gotoEdit"
      >
        <section v-if="hasAddress" class="crowdfunding-pay__address-user">
          {{ nowAddress.consignee }}&nbsp;&nbsp;{{ nowAddress.mobile }}
        </section>
        <section class="crowdfunding-pay__address-detail">
          <i class="icon position"></i>
          <div>{{ showAddress(nowAddress, "新增地址") }}</div>
          <i :class="['icon', hasAddress ? 'left_arrow' : 'address_add']"></i>
        </section>
        <p v-if="errorMsg" class="crowdfunding-pay__address-error">
          {{ errorMsg }}
        </p>
      </div>
      <div class="crowdfunding-pay__content">
        <div class="crowdfunding-pay__content-transway">
          <span>配送方式</span>
          <span>{{ getTransway(form.shippingPrice) }}</span>
        </div>
        <div class="crowdfunding-pay__content-price">
          <div>共计{{ form.goodsNum }}件商品</div>
        </div>
      </div>
      <ul class="crowdfunding-pay__price">
        <li>
          <span>商品总价</span>
          <span>{{ orderGoodsTotalPrice }}</span>
        </li>
        <li>
          <span>运费</span>
          <span>￥{{ form.shippingPrice }}</span>
        </li>
        <li>
          <span>应付总额</span>
          <span class="active">{{ orderGoodsPaymentPrice }}</span>
        </li>
      </ul>
      <div class="crowdfunding-pay__order-tip">
        <div>订单查询</div>
        <div>芒果TV App-个人中心-芒果好物内查询订单</div>
      </div>
    </div>
    <div class="crowdfunding-pay__bottom">
      <div>
        总计：
        <span>{{ orderGoodsPaymentPrice }}</span>
      </div>
      <div
          :mg-stat-lob="`crowdId =${crowdId}`"
          mg-stat-click
          mg-stat-custom="cntp=haowu_pay&cont=立即支付&direct=web&cntp=haowu_pay&mod=pay_address&mod=confrim_payment&label=btn"
          mg-stat-mod="confrim_payment"
          @click="readyPay"
      >
        立即支付
      </div>
    </div>
    <Pay
        :couponId="couponId"
        :crowdId="crowdId"
        :goodsids="goodsids"
        :goodsidsAndNum="goodsidsAndNum"
        :isShow="isShowPay"
        :needGo="true"
        :orderId="orderId"
        :originPage="originPage"
        :price="orderGoodsPaymentPrice"
        :specids="specids"
        @changeVisible="(val) => (isShowPay = val)"
        @clickPay="uploadClose"
    ></Pay>
  </div>
</template>
<script>
import _ from 'lodash';
import FixedHeader from 'components/common/FixedHeader';
import GoodsTags from 'components/common/GoodsTags';
import Pay from 'components/common/Pay';
import MySwitch from 'components/common/Switch';
import { mapMutations } from 'vuex';
import * as userApis from 'apis/user';
import * as orderApis from 'apis/order';
import { showAddress } from 'utils/order';
import DataStorage from 'utils/dataStore';
import {
  beforeRouteChange,
  getDevicePlatForm,
  getGoodsSizeNum,
  initCloseUpload,
  uploadCloseData,
  uploadSubmitOrder,
} from 'utils/uploadData';
import MgtvApi from 'MgtvApi';
import MgStat from 'MgStat';

export default {
  components: {
    FixedHeader,
    Pay,
    MySwitch,
    GoodsTags,
  },
  data() {
    // address_id是从地址管理页面带过来
    const {
      query: { addressId },
    } = this.$route;
    return {
      nowAddressId: addressId ? Number(addressId) : 0,
      isEdit: false,
      isSelectAll: false,
      isShowPay: false,
      orderId: null,
      originPage: this,
      errorMsg: '',
      nowAddress: {
        consignee: '',
        mobile: '',
        province: {
          id: '',
          name: '',
        },
        city: {
          id: '',
          name: '',
        },
        district: {
          id: '',
          name: '',
        },
        address: '',
        addressId: 0,
        isDefault: false,
      },
      hasNoAddress: 1,
      form: {
        cartList: [],
        couponPrice: 0, // 优惠券抵扣
        discountPrice: 0, // 折扣价格
        goodsNum: 0, // 订单商品总数
        goodsPrice: 0, // 订单商品总价
        integral: 0, // 积分价格
        integralPrice: 0, // 积分抵扣价格
        payableAmount: 0, // 应付金额
        promotionPrice: 0, // 活动抵扣
        shippingPrice: 0, // 快递费用
        balancePrice: 0, // 余额抵扣
      },
      hasAnyAction: false,
      hasRouteChange: false,
      hasCoupon: 1,
      showCoupon: false,
      couponId: 0,
      couponPrice: 0,
      couponList: [],
      goodsids: '',
      goodsidsAndNum: '',
      specids: '',
      crowdId: null,
      paying: false,
    };
  },
  watch: {
    hasAnyAction: {
      handler(val) {
        DataStorage.setPageVisitiLog(val);
      },
      immediate: true,
    },
    showCoupon: {
      handler(val) {
        if (val) {
          MgStat.send(
            'cv',
            {
              couponid: this.couponId,
              goods_id: this.goodsids,
            },
            {
              mod: 'c_hwcouponpop',
            },
          );
        }
      },
      immediate: true,
    },
    $route: {
      handler(val, oldVal) {
        console.log(val, oldVal);
      },
      // 深度观察监听
      deep: true,
    },
  },
  computed: {
    hasAddress() {
      const { nowAddress } = this;
      return nowAddress && nowAddress.addressId;
    },
    // 计算结算单商品总价
    orderGoodsTotalPrice() {
      const { form } = this;
      if (form.integral) {
        if (form.payableAmount) {
          return `${form.integral}积分 + ¥ ${form.payableAmount}`;
        }
        return `${form.integral}积分`;
      }
      // 纯积分
      return `¥${form.goodsPrice}`;
    },
    // 计算结算单应付总价
    orderGoodsPaymentPrice() {
      const { form } = this;
      if (form.integral) {
        if (form.payableAmount) {
          return `${form.integral}积分 + ¥ ${form.payableAmount}`;
        }
        return `${form.integral}积分`;
      }
      // 纯积分
      return `¥${form.payableAmount}`;
    },
  },
  async created() {
    await this.fetchAddressList();
    this.getCrowdPrice();
  },
  mounted() {
    initCloseUpload();
    document
      .getElementsByTagName('html')[0]
      .setAttribute('mg-stat-page', 'haowu_pay');
    MgStat.send(
      'pv',
      { crowdId: this.$route.query.crowdId },
      { cntp: 'haowu_pay' },
    );
  },
  beforeRouteLeave(to, from, next) {
    if (!this.hasRouteChange) {
      uploadCloseData();
    }
    next();
  },
  methods: {
    showAddress,
    ...mapMutations('pay', [
      'changeUserNote',
      'changeMobile',
      'changePreRule',
      'clearNoteData',
    ]),
    async readyPay() {
      const addressId = this.nowAddressId;
      if (!addressId) {
        this.$toast('请选择地址');
        return;
      }
      if (!this.paying) {
        this.paying = true;
        if (this.orderId == null) {
          // 如果本次页面已经拉起过支付，则就不用再次下单用原有订单进行支付拉起
          const { ladderId, count } = this.$route.query;
          try {
            const d = DataStorage.getFixedUploadParams();
            let uid = '';
            let entry = '';
            let from = '';
            let propb = '';
            if (d) {
              // eslint-disable-next-line prefer-destructuring
              uid = d.uid;
              // eslint-disable-next-line prefer-destructuring
              entry = d.entry;
              // eslint-disable-next-line prefer-destructuring
              from = d.from;
              // eslint-disable-next-line prefer-destructuring
              propb = d.propb;
            }
            const platform = getDevicePlatForm();
            const data = await orderApis.submitOrder({
              addressId,
              ladderId,
              goodsNum: count,
              did: uid,
              from,
              entry,
              propb,
              platform,
              action: 'buy_now',
            });
            if (data) {
              this.isShowPay = true;
              this.orderId = data;
              MgStat.send(
                'click',
                {
                  order_id: data,
                  crowdId: this.crowdId,
                  status: 0,
                },
                {
                  mod: 'confrim_payment',
                  cont: '订单结果',
                  direct: 'cntp',
                  label: 'text',
                  cntp: 'haowu_pay',
                },
              );
            }
          } catch (error) {
            const { message } = error;
            this.$toast(`众筹订单支付失败:${message}`);
          }
        }
      } else {
        this.$toast('请勿重复下单');
      }
    },
    async getCrowdPrice() {
      const {
        ladderId, count, crowdId, goods_id,
      } = this.$route.query;
      this.crowdId = crowdId;
      this.goodsids = goods_id;
      try {
        const param = {
          ladderId,
          goodsNum: count,
          action: 'buy_now',
        };
        const data = await orderApis.getOrderCalculateInfo(param);
        if (!_.isEmpty(data)) {
          _.assign(this.form, data);
        }
      } catch (error) {
        const { message } = error;
        this.$toast(`计算众筹详情失败:${message}`);
      }
    },
    async uploadClose(callback) {
      this.hasRouteChange = true; // 支付成功回来之后 路由会变化 但是支付的时候已经上报了  所以设置为true 不再上报
      await uploadCloseData();
      if (typeof callback === 'function') {
        callback();
      }
    },
    uploadOrderData() {
      const {
        orderId: orderid,
        form: { cartList, total_amount: price },
      } = this;
      uploadSubmitOrder({ orderid, price, ...getGoodsSizeNum(cartList) });
    },
    getTransway(val) {
      if (typeof val === 'number') {
        if (!val) {
          return '快递包邮';
        }
        return `￥${val}`;
      }
      return '-';
    },
    // 获取地址
    async fetchAddressList() {
      const data = await userApis.getAddressList();
      if (Array.isArray(data)) {
        let adderss;
        if (!this.nowAddressId) {
          /* 没有id则用默认值 */
          [adderss] = data.filter(f => f.isDefault);
        } else {
          [adderss] = data.filter(f => f.addressId === this.nowAddressId);
          if (!adderss) {
            /* 如果没匹配到数据 说明地址被删除了 */
            this.$router.replace('/cfPay');
            /* 安卓端 页面刷新 title就会变化 所以在此需要再执行一遍 */
            MgtvApi.setWebviewTitle({ title: '芒果好物' });
            this.nowAddressId = 0;
          }
        }
        if (!_.isEmpty(adderss)) {
          this.nowAddressId = adderss.addressId;
          this.nowAddress = adderss;
        }
        if (!data.length) {
          this.hasNoAddress = 1;
        } else {
          this.hasNoAddress = 0;
        }
      }
    },
    gotoEdit() {
      const queryParams = JSON.stringify(this.$route.query);
      if (this.hasNoAddress) {
        beforeRouteChange(
          {
            path: '/address/edit',
            query: { from: 'cfPay', redirect: 'redirect', queryParams },
          },
          this,
        );
      } else {
        beforeRouteChange(
          {
            path: '/address/manage',
            query: { from: 'cfPay', redirect: 'redirect', queryParams },
          },
          this,
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.crowdfunding-pay {
  height: 100%;

  &__main {
    height: 100%;
    box-sizing: border-box;
    padding: 0 30px 98px 30px;
  }

  &__address {
    padding: 34px 26px;
    background: #ffffff;
    border-radius: 20px;
    margin: 30px 0px 20px 0px;

    &-user {
      font-size: 28px;
      color: #000000;
      margin-bottom: 20px;
    }

    &-detail {
      display: flex;
      align-items: center;

      div:nth-child(1),
      div:nth-child(3) {
        width: 30px;
      }

      div:nth-child(2) {
        flex: 1;
        font-size: 30px;
        margin: 0 40px;
        color: #000000;
      }
    }

    &-error {
      font-size: 20px;
      color: #f47125;
      padding: 10px 60px 0 60px;
      word-break: break-all;
    }
  }

  &__content {
    margin-bottom: 30px;
    padding: 20px 26px;
    background: #ffffff;
    border-radius: 20px;

    &-sku {
      padding: 24px 0;
      display: flex;
      border-bottom: 2px solid rgba(211, 211, 211, 0.5);

      section:nth-child(1) {
        width: 170px;
        height: 170px;
        margin-right: 30px;

        img {
          height: 100%;
          max-width: 100%;
        }
      }

      section:nth-child(2) {
        flex: 1;

        div:nth-of-type(1) {
          font-size: 28px;
          color: #000000;
          margin-bottom: 14px;
        }

        div:nth-of-type(2) {
          font-size: 26px;
          color: #4a4a4a;
          margin-bottom: 14px;
        }

        div:nth-of-type(3) {
          display: flex;
          justify-content: space-between;
          align-items: center;

          span:nth-child(1) {
            font-size: 32px;
            color: #ff4c00;
          }

          span:nth-child(2) {
            font-size: 24px;
            color: #99948e;
          }
        }
      }
    }

    &-transway {
      display: flex;
      justify-content: space-between;
      border-bottom: 2px solid rgba(211, 211, 211, 0.5);
      padding: 0 8px;
      height: 68px;
      line-height: 68px;
      font-size: 24px;
      color: #000000;
    }

    &-remark {
      @extend .crowdfunding-pay__content-transway;

      div:first-child {
        width: 114px;
        margin-right: 30px;
      }

      div:last-child {
        flex: 1;

        input {
          font-size: 24px;
          padding-right: 20px;
          box-sizing: border-box;
        }
      }
    }

    &-price {
      @extend .crowdfunding-pay__content-transway;
      border: none;
      justify-content: flex-end;

      div + div {
        margin-left: 20px;
      }

      span:last-child {
        color: #ff4c00;
        font-weight: 600;
      }
    }
  }

  &__presell {
    border-radius: 20px;
    background: #fff;
    padding: 20px 30px;
    margin: 20px 0px;

    &-phone {
      display: flex;
      font-size: 22px;
      white-space: nowrap;
      padding-bottom: 20px;
      border-bottom: 2px solid rgba(211, 211, 211, 0.5);
    }

    &-tip {
      p {
        font-size: 22px;

        &:nth-of-type(1) {
          color: #ff5400;
          margin: 20px 0 26px 0;
          font-weight: bold;
        }

        &:nth-of-type(2) {
          display: flex;
          justify-content: space-between;
        }
      }
    }

    &-info {
      border-bottom: 2px solid rgba(211, 211, 211, 0.5);

      p {
        display: flex;
        justify-content: space-between;
        margin: 20px 0;
        font-size: 22px;

        &:nth-of-type(1) {
          span:last-of-type() {
            color: #ff5400;
          }
        }
      }
    }
  }

  &__price {
    border-radius: 20px;
    background: #fff;
    padding: 0px 30px;
    margin: 20px 0px;
    font-size: 22px;

    .active {
      color: #ff5f00 !important;
    }

    li {
      height: 55px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 2px solid rgba(211, 211, 211, 0.5);

      &:last-of-type {
        border: none;

        span {
          &:first-of-type {
            color: #000000;
          }
        }
      }

      span {
        &:first-of-type {
          color: #4a4a4a;
        }

        &:last-of-type {
          color: #000000;
        }
      }
    }
  }

  &__order-tip {
    background: #fff;
    border-radius: 20px;
    padding-left: 30px;
    overflow: hidden;
    margin-bottom: 180px;
    @extend .crowdfunding-pay__content-remark;
  }

  &__bottom {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    background: #fff;
    font-size: 30px;

    div {
      height: 98px;
      line-height: 98px;
    }

    div:first-child {
      padding: 0 30px;
      flex: 1;
      color: #000000;

      span {
        color: #ff4c00;
        font-weight: 600;
      }
    }

    div:last-child {
      width: 280px;
      background: #ff5f00;
      color: #fff;
      text-align: center;
    }
  }
}
</style>
